import { CaseResponse, DetailLink, ComplaintResponse } from '@/types/types';

export const getCaseLinks = (caseResponse: CaseResponse): DetailLink[] => {
	if (!caseResponse) return [];
	let links = [] as DetailLink[];
	caseResponse.links?.forEach((link) => {
		links.push({
			link: link,
			isNew: false,
		});
	});
	caseResponse.complaints?.forEach((complaint) => {
		complaint.links?.forEach((link) => {
			links.push({
				link: link,
				isNew: false,
			});
		});
		complaint.callbacks?.forEach((callback) => {
			callback.links?.forEach((link) => {
				links.push({
					link: link,
					isNew: false,
				});
			});
		});
	});
	caseResponse.statements?.forEach((statement) => {
		statement.links?.forEach((link) => {
			links.push({
				link: link,
				isNew: false,
			});
		});
	});
	return links;
};

export const getComplaintLinks = (complaintResponse: ComplaintResponse): DetailLink[] => {
	if (!complaintResponse) return [];
	let links = [] as DetailLink[];
	complaintResponse.links?.forEach((link) => {
		links.push({
			link: link,
			isNew: false,
		});
	});

	complaintResponse.callbacks?.forEach((callback) => {
		callback.links?.forEach((link) => {
			links.push({
				link: link,
				isNew: false,
			});
		});
	});
	return links;
};
